import $ from 'jquery';
import Page from './page';
import { setInitialState } from './catalog/set_initial_state';
import { handleStatusbarPosition } from './catalog/handle_statusbar_position';
import { initializeTyrePageModules } from './catalog/initialize_page_modules/tyre_page_modules';
import { types as productTypes } from '../_constants/product/types';
import { foldSEOText } from './catalog/fold_seo_text';
import ActiveStationStore from '../_flux/stores/active_station_store';
import { renderFittingStationFinder } from '../_flux/components/fitting_station_finder/fitting_station_finder';
import ActiveStationActions from '../_flux/actions/active_station_actions';
import CatalogItemStore from '../_flux/stores/catalog_items_store';
import GooglePlaces from '../addressify/google/google_places';
import setGeoLocation from '../utilities/geoLocation';
import { init as initClearanceInfoLightBox } from '../_views/clearance_info_light_box/clearance_info_light_box';
import { init as initInfoPopup } from '../_views/info_popup/info_popup_view';
import { InfoPopupContainer } from '../_constants/info_popup';

/**
 * @extends Page
 */

class CatalogTyrePage extends Page {
  static _name = 'CatalogTyrePage';

  init() {
    super.init();

    setGeoLocation('catalog');
    if (this.$container.length) {
      setInitialState();
      initializeTyrePageModules(this.productType);
      handleStatusbarPosition(this.$container);
      foldSEOText();
      this.initFittingStationFinder(this.productType);
      initClearanceInfoLightBox(document.getElementById('clearance-info'));
      initInfoPopup(document.getElementById(InfoPopupContainer), {});
    }
  }

  /**
   * @return {CatalogTyrePage}
   */
  initGooglePlace() {
    window.googlePlace = new GooglePlaces({ country: TYROOLA.globals.countryMainStore });
    return this;
  }

  initFittingStationFinder(productType) {
    if (productTypes.TYRE_CAR === productType) {
      TYROOLA.mapsInitiated.then(() => {
        this.initGooglePlace();

        renderFittingStationFinder({
          containerDOMNode: document.getElementById('fsf'),
          showSelectStationButton: true,
          showSuccessPage: true,
          showQuantityInput: true,
          onStationSelect: this._onStationSelect.bind(this),
          onWheels2Change: this._onWheels2Change.bind(this),
          onWheels4Change: this._onWheels4Change.bind(this),
        });
      });
    }

    return this;
  }
  async _onStationSelect(station) {
    const activeStationStoreState = ActiveStationStore.getState();
    const wheelAlignment2 = activeStationStoreState.wheelAlignment.wheels2.indexOf(station.id) !== -1;
    const wheelAlignment4 = activeStationStoreState.wheelAlignment.wheels4.indexOf(station.id) !== -1;
    const products = CatalogItemStore.getState().products;
    const isMpsOrder = station?.productStock?.frontendPrice ?? false;
    const productId = isMpsOrder ? station.productStock.spinachId : products[0].id;
    await ActiveStationActions.setActiveStationAction(station, true, wheelAlignment2, wheelAlignment4);
    ActiveStationActions.addProductToCartAction(station, productId, isMpsOrder, true, wheelAlignment2, wheelAlignment4);
  }
  _onWheels2Change(stationId, isChecked) {
    const action = isChecked ? ActiveStationActions.setWheelAlignment : ActiveStationActions.unsetWheelAlignment;
    action('2', stationId);
  }

  _onWheels4Change(stationId, isChecked) {
    const action = isChecked ? ActiveStationActions.setWheelAlignment : ActiveStationActions.unsetWheelAlignment;
    action('4', stationId);
  }
}

export default CatalogTyrePage;
